import { render, staticRenderFns } from "./PetTrackingDeviceSubscriptionProduct.vue?vue&type=template&id=87f0c1d2&scoped=true&"
import script from "./PetTrackingDeviceSubscriptionProduct.vue?vue&type=script&lang=js&"
export * from "./PetTrackingDeviceSubscriptionProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f0c1d2",
  null
  
)

export default component.exports